// @flow

import React from 'react';
import Button from './actionButton';
import { getVariant, getColor, getSize } from '../button/helpers';
import type { ACFProps } from '../button';

type Props = {
  ...ACFProps,
  loading: boolean,
  disabled?: boolean,
};

const ACFButton = ({
  icon,
  position,
  template,
  text,
  page,
  url,
  with_icon,
  size,
  type,
  loading,
  disabled,
}: Props) => (
  <Button
    variant={getVariant(template)}
    colors={getColor(template)}
    position={position}
    href={url || page}
    icon={icon}
    size={getSize(size, template)}
    withIcon={with_icon}
    type={type}
    loading={loading}
    disabled={disabled || loading}
  >
    {text}
  </Button>
);

ACFButton.defaultProps = {
  disabled: false,
};

export default ACFButton;
